import React, { FC, useState } from 'react';
import { Button, Modal, Tag, Text, Title } from '@carnica/ui-kit';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import classNames from 'classnames/bind';

import { ACCUMS_TEXTS } from 'constants/accumulators';
import { getFormattedCtn } from 'utils';

import styles from './styles.pcss';

type TagPropsType = {
  mainCtn: string;
  size?: 'm' | 's';
};

const cn = classNames.bind(styles);

export const AccumulatorsInfoTag: FC<TagPropsType> = ({ mainCtn, size = 's' }) => {
  const [isOpen, setOpen] = useState(false);
  const isMobile = useIsMobileDimension();

  const handleModalClose = () => {
    setOpen(false);
  };

  const handleModalOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setOpen(true);
  };

  return (
    <>
      <Tag
        className={cn('tag')}
        onClick={handleModalOpen}
        size={size}
        tagName="button"
        view="light"
      >
        {ACCUMS_TEXTS.sharingText.slave}
      </Tag>
      <Modal isOpen={isOpen} onClose={handleModalClose}>
        <Title
          align="left"
          className={cn('title')}
          size="l"
          title={`${ACCUMS_TEXTS.modal.title} ${getFormattedCtn(mainCtn)}`}
        />
        <div className={cn('container')}>
          <Text color="secondary" size="m">
            {ACCUMS_TEXTS.modal.text}
          </Text>
        </div>
        <Button onClick={handleModalClose} width={isMobile ? 'full' : 'default'}>
          {ACCUMS_TEXTS.modal.btnText}
        </Button>
      </Modal>
    </>
  );
};
